<template>
  <BaseCard>
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'overview' }]"
      @click="section = 'overview'"
      v-test="'sp-nav-overview'"
    >
      <BaseText iconBefore="home">
        {{ $t('register.salonized_pay.dashboard.overview.heading') }}
      </BaseText>
    </div>
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'payouts', [$style.isDisabled]: !verified }]"
      @click="verified && (section = 'payouts')"
      v-test="'sp-nav-payouts'"
    >
      <BaseText iconBefore="activity">
        {{ $t('register.salonized_pay.dashboard.payouts') }}
      </BaseText>
    </div>
    <div
      v-if="showWallets"
      :class="[$style.navItem, { [$style.isActive]: section === 'wallets', [$style.isDisabled]: !verified }]"
      @click="verified && (section = 'wallets')"
      v-test="'sp-nav-wallets'"
    >
      <BaseText iconBefore="percentage">
        {{ $t('register.salonized_pay.dashboard.wallets.heading') }}
      </BaseText>
    </div>
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'terminals', [$style.isDisabled]: !verified }]"
      @click="verified && (section = 'terminals')"
      v-test="'sp-nav-terminals'"
    >
      <BaseText iconBefore="mobile">
        {{ $t('register.salonized_pay.dashboard.terminals_page.heading') }}
      </BaseText>
    </div>
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'business-details', [$style.isDisabled]: !verified }]"
      @click="verified && (section = 'business-details')"
      v-test="'sp-nav-business-details'"
    >
      <BaseText iconBefore="briefcase">
        {{ $t('register.salonized_pay.dashboard.business_details.heading') }}
      </BaseText>
    </div>
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'settings', [$style.isDisabled]: !verified }]"
      @click="verified && (section = 'settings')"
      v-test="'sp-nav-settings'"
    >
      <BaseText iconBefore="settings">
        {{ $t('register.salonized_pay.dashboard.settings') }}
      </BaseText>
    </div>
    <div :class="$style.divider" />
    <div
      :class="[$style.navItem, { [$style.isActive]: section === 'help' }]"
      @click="section = 'help'"
      v-test="'sp-nav-help'"
    >
      <BaseText iconBefore="question-mark">
        {{ $t('register.salonized_pay.dashboard.help.heading') }}
      </BaseText>
    </div>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { useUserStore } from '@/stores/user';
import unleash from '@/unleash';

const section = defineModel<
  | 'overview'
  | 'payouts'
  | 'wallets'
  | 'terminals'
  | 'business-details'
  | 'settings'
  | 'help'
>('section', { required: true });

defineProps<{
  verified: boolean;
}>();

const { hasFeatureFlag } = useUserStore();

const showWallets = computed(
  () =>
    unleash.isEnabled('SplitWallets') && hasFeatureFlag('admin-salonized-pay'),
);
</script>

<style
  lang="scss"
  module
>
.navItem {
  display: block;
  width: 100%;
  padding: $spacing;
  border-radius: $radius;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.25;
  }

  &.isActive {
    background-color: var(--color-highlight);
  }

  @include hover {
    background-color: var(--color-highlight);
  }

  &.isDisabled {
    cursor: not-allowed;
    opacity: 0.5;

    @include hover {
      background-color: transparent;
    }
  }
}

.divider {
  border-top: 1px solid var(--color-border);
  margin: $spacing * 0.5 0;
}
</style>
